module.exports = __webpack_public_path__ + "img/直播场景_娱乐直播.da0e16e0.png";